export const getGeometryCoordinates = geometry => {
    const coordinates = [];

    if (!geometry) {
        return coordinates;
    }

    if (geometry.type === 'Polygon') {
        geometry.coordinates.forEach(ring => {
            ring.forEach(([lon, lat]) => coordinates.push([lon, lat]));
        });
    }

    if (geometry.type === 'MultiPolygon') {
        geometry.coordinates.forEach(polygon => {
            polygon.forEach(ring => {
                ring.forEach(([lon, lat]) => coordinates.push([lon, lat]));
            });
        });
    }

    return coordinates;
};

export const getBounds = features => {
    const allCoordinates = features.flatMap(feature => getGeometryCoordinates(feature.geometry));
    const lons = allCoordinates.map(([lon]) => lon);
    const lats = allCoordinates.map(([, lat]) => lat);

    return {
        minLon: Math.min(...lons),
        maxLon: Math.max(...lons),
        minLat: Math.min(...lats),
        maxLat: Math.max(...lats),
    };
};

export const projectPoint = ({ lon, lat }, bounds, width, height, padding) => {
    const x = padding + ((lon - bounds.minLon) / (bounds.maxLon - bounds.minLon)) * (width - padding * 2);
    const y = padding + ((bounds.maxLat - lat) / (bounds.maxLat - bounds.minLat)) * (height - padding * 2);
    return { x, y };
};

export const unprojectPoint = ({ x, y }, bounds, width, height, padding) => {
    const lon = bounds.minLon + ((x - padding) / (width - padding * 2)) * (bounds.maxLon - bounds.minLon);
    const lat = bounds.maxLat - ((y - padding) / (height - padding * 2)) * (bounds.maxLat - bounds.minLat);
    return { lat, lon };
};

export const geometryToPath = (geometry, bounds, width, height, padding) => {
    const ringToPath = ring => {
        return ring
            .map(([lon, lat], index) => {
                const { x, y } = projectPoint({ lon, lat }, bounds, width, height, padding);
                return `${index === 0 ? 'M' : 'L'} ${x.toFixed(2)} ${y.toFixed(2)}`;
            })
            .join(' ')
            .concat(' Z');
    };

    if (geometry.type === 'Polygon') {
        return geometry.coordinates.map(ringToPath).join(' ');
    }

    if (geometry.type === 'MultiPolygon') {
        return geometry.coordinates.flatMap(polygon => polygon.map(ringToPath)).join(' ');
    }

    return '';
};
